<template>
  <div class="container">
    <HeadingOne class="-margin-md">メンテナンス中</HeadingOne>

    <section>
      <p>
        ただいまシステムメンテナンス中です。<br />
        終了次第、サービスを再開いたしますので、いましばらくお待ちください。<br />
        ご迷惑をおかけし誠に申し訳ございませんが、ご理解のほどよろしくお願い申しあげます。<br />
        ※メンテナンス時間につきましては、au PAY
        スマートローントップの「重要なお知らせ」をご覧ください。
      </p>
    </section>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main -md" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Tem031",
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "メンテナンス中",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
